import { ROLES } from "~/shared.types";
import { useUserStore } from "~/stores";

export const usePermissions = () => {
  const { role } = useUserStore();

  const isSuperAdmin = role === ROLES.SUPER_ADMIN.value;
  const isAdminOrAbove = isSuperAdmin || role === ROLES.ADMIN.value;
  const isStaffOrAbove = isAdminOrAbove || role === ROLES.STAFF.value;

  return {
    canCreateUser: isAdminOrAbove,
    canEditUserType: isSuperAdmin,
    canEditSource: isAdminOrAbove,
    canMarkAsTest: isAdminOrAbove,
    canEditUserEmail: isAdminOrAbove,
    canSendMagicLink: isStaffOrAbove,
    canBookVisit: isStaffOrAbove,
    canViewProviderSchedule: isStaffOrAbove,
    canEditProviderSchedule: isAdminOrAbove,
    canManageBanners: isAdminOrAbove,
    canViewBanners: isStaffOrAbove,
    canManageInsuranceProviders: isSuperAdmin,
    canManageGlobalScheduleRules: isAdminOrAbove,
    canViewUserEvents: isAdminOrAbove,
  };
};
